// Adventure Orthodontics (Dr. McCord; Idaho) - three online-bookable offices:
// Idaho Falls, Pocatello (Chubbuck), Shelley. (Victor is not online-bookable.)
// Backend: bondLocations.ts ADVENTURE_IDAHO_FALLS / _POCATELLO / _SHELLEY (brandId
// "adventure", catalog b8503aca, Edge loc 2/3/4, procedure 244, DB 353). Native
// booking via ortho2-newpatient backend (WCF intake disabled). English-only.
import type { BrandConfig } from "./types";

export const adventure: BrandConfig = {
  slug: "adventure",
  brandId: "adventure",
  brandName: "Adventure Orthodontics",
  logo: "https://edgestorage.ortho2.com/logos/6925bff3-d572-4286-b7be-4398c3527353.png",
  phone: "(208) 529-8333",
  phoneHref: "tel:+12085298333",
  theme: { primary: "#2E9D98", primaryDark: "#1F6E6A" }, // scoured 2026-07-20 adventurebraces.com (teal)
  locales: ["en"],
  locations: {
    ADVENTURE_IDAHO_FALLS: {
      id: "ADVENTURE_IDAHO_FALLS",
      name: "Idaho Falls",
      addressLines: ["1943 Madison Ave", "Idaho Falls, ID 83404"],
      mapsUrl: "https://maps.google.com/?q=1943+Madison+Ave+Idaho+Falls+ID+83404",
      timezone: "America/Boise",
    },
    ADVENTURE_POCATELLO: {
      id: "ADVENTURE_POCATELLO",
      name: "Pocatello",
      addressLines: ["732 W Quinn Rd, Ste 200", "Chubbuck, ID 83202"],
      mapsUrl: "https://maps.google.com/?q=732+W+Quinn+Rd+Ste+200+Chubbuck+ID+83202",
      timezone: "America/Boise",
    },
    ADVENTURE_SHELLEY: {
      id: "ADVENTURE_SHELLEY",
      name: "Shelley",
      addressLines: ["498 S State St", "Shelley, ID 83274"],
      mapsUrl: "https://maps.google.com/?q=498+S+State+St+Shelley+ID+83274",
      timezone: "America/Boise",
    },
  },
  locationAliases: {
    IDAHO_FALLS: "ADVENTURE_IDAHO_FALLS",
    POCATELLO: "ADVENTURE_POCATELLO",
    CHUBBUCK: "ADVENTURE_POCATELLO",
    SHELLEY: "ADVENTURE_SHELLEY",
  },
};
